import type { ReactNode } from 'react';
import { Box } from '@radix-ui/themes';
import styled from '@emotion/styled';

interface FooterProps {
  children: ReactNode;
}

const FooterWrapper = styled.div`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index: 10;
  border-top: 1px solid var(--gray-a4);
`;

export function Footer({ children }: FooterProps) {
  return (
    <FooterWrapper>
      <Box
        p="4"
        mx="auto"
        style={{
          maxWidth: 768,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </FooterWrapper>
  );
}
